import React from 'react';
import { Box, Typography, Link, Container, Paper } from '@mui/material';
import { useLanguage, languages } from './data/languages';

const PrivacyPolicy = () => { // 隐私政策页面组件
  const currentLang = useLanguage();
  const config = languages[currentLang] || languages.en;

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center">
          {config.privacyPolicy.title}
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Typography variant="body1" paragraph>
            {config.privacyPolicy.description}
          </Typography>

          <Box sx={{ textAlign: 'center', mt: 4 }}>
            <Link
              href="https://gintarot.com"
              target="_blank"
              rel="noopener noreferrer"
              variant="h6"
              sx={{
                color: 'primary.main',
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              {config.privacyPolicy.linkText}
            </Link>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicy;
